import { gql } from '@apollo/client'

export default gql(`
    mutation dismissNotification($id: ID!){
        dismissNotification(
            id: $id
        ) {
            id
        }
}`)
